import { ApiListing } from 'api/types/ApiListing';
import { LISTING_TYPE_URL_SEGMENT_MAP } from 'utils/constants';
import { getJson } from 'utils/http';

export function apiFetchListing(
  listingType: keyof typeof LISTING_TYPE_URL_SEGMENT_MAP,
  listingId: string,
): Promise<ApiListing> {
  return getJson(
    `/data/website/${LISTING_TYPE_URL_SEGMENT_MAP[listingType]}/${listingId}`,
  ).then(
    // @ts-expect-error TS(2345): Argument of type '({ data, job, internship, volop ... Remove this comment to see the full error message
    ({ data, job, internship, volop }) => data || job || internship || volop,
  );
}
